import { IEntity } from './IEntity';

export const resourceNameGoal = `goal`;

export interface IGoal extends IEntity {
	name: string;
	icon: string;
	startdate: string;
	verb: string;
	weeklyrate: number;
	isarchived: boolean;
	istracking: boolean;
	isupper: boolean;
	is1time: boolean;
	iscommentrequired: boolean;
	isdaily: boolean;
	energyrank?: number;
	daysleft: number;
	notes: string | null;
	goalindangerdayslimit: number;
	goalhideuntildayslimit: number;
	isresonating: boolean;
	difficulty: number;
    lastresonance: string | null;
	
	[x: string]: any;
}
